import { useEffect, useRef, useState } from "react";
import api from "../../lib/api";
import { Bell, Check } from "lucide-react";
import { Button } from "../ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { fmtDateTime } from "../../lib/api";

export default function NotificationBell() {
  const [data, setData] = useState({ items: [], unread_count: 0 });
  const [open, setOpen] = useState(false);
  const timer = useRef();

  const load = () => api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    timer.current = setInterval(load, 15000);
    return () => clearInterval(timer.current);
  }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const readOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="relative p-2 rounded-lg hover:bg-slate-100" data-testid="notifications-bell" aria-label="Bildirimler">
          <Bell size={20} className="text-slate-700" />
          {data.unread_count > 0 && (
            <span className="absolute top-1 right-1 min-w-[18px] h-[18px] rounded-full bg-rose-600 text-white text-[10px] font-bold grid place-items-center px-1">
              {data.unread_count > 99 ? "99+" : data.unread_count}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 sm:w-96 p-0">
        <div className="flex items-center justify-between p-3 border-b border-slate-200">
          <div className="font-bold text-slate-900">Bildirimler</div>
          {data.unread_count > 0 && (
            <Button variant="ghost" size="sm" onClick={readAll} className="gap-1 h-7 text-xs" data-testid="notif-read-all">
              <Check size={14} /> Tümünü okundu işaretle
            </Button>
          )}
        </div>
        <div className="max-h-96 overflow-y-auto">
          {data.items.length === 0 && <div className="p-8 text-center text-sm text-slate-400">Bildirim yok</div>}
          {data.items.map((n) => (
            <div
              key={n.id}
              className={`p-3 border-b border-slate-100 cursor-pointer hover:bg-slate-50 ${!n.read ? "bg-emerald-50/40" : ""}`}
              onClick={() => !n.read && readOne(n.id)}
              data-testid={`notif-item-${n.id}`}
            >
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-semibold text-slate-900 text-sm">{n.title}</div>
                  <div className="text-xs text-slate-600 mt-0.5 line-clamp-2">{n.message}</div>
                  <div className="text-[10px] text-slate-400 mt-1">{fmtDateTime(n.created_at)}</div>
                </div>
                {!n.read && <span className="h-2 w-2 rounded-full bg-emerald-600 mt-1.5 shrink-0" />}
              </div>
            </div>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
